// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"e_iq","popupBlock":"e_jq"};